import BackButtonPage from '../../../../../components/BackButtonPage';
import "../../../../../styles/AdottTortenelmiPillanat.css"


function TargyiLeletek() {
  return (
    <div className='page-content-container'>
        <img src="/assets/ter_segedlet/targyi_leletek.png" className='responsive-img' alt="Tárgyi leletek" />

        <a 
        className="zold-kiemeles" 
        href="https://reenactor.hu/wear/xvi/xvihunmoh/?fbclid=IwY2xjawHk38hleHRuA2FlbQIxMAABHRl-H9y5y0GN-Sd7CfnbSXOP03GNPL1Kr7o2y-kdZ4rxHvLGXc0-GluP2w_aem_IucZwZsypxJ7--sgzYWzOw" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{ marginBottom: "calc(5px + 2vh)" }}
        >
        További tárgyi leletek és egykorú ábrázolások megtekintéséhez szívből ajánjuk a 
        www.reenactor.hu oldalt, ahol tematikus bontásban dolgozták fel ezt az történelmi
        időszakot (is). Ide kattintva, a XVI. század eleji gyűjteményük nyitható meg.
        </a>
        <BackButtonPage to="/ter-segedlet" />
    </div>
  );
}

export default TargyiLeletek;
